import { Card, Col, Row } from "react-bootstrap"

export default function UsersDashboardCards({users}) {

    return (

        <Row className="mb-4">

            <Col md={3}>
                <Card className="shadow-sm">
                    <Card.Body>
                        <h6>Usuários Ativos</h6>
                        <h3>{users.filter(item => item.active == 1).length}</h3>
                    </Card.Body>
                </Card>
            </Col>

            <Col md={3}>
                <Card className="shadow-sm">
                    <Card.Body>
                        <h6>Usuários Inativos</h6>
                        <h3>{users.filter(item => item.active !== 1).length}</h3>
                    </Card.Body>
                </Card>
            </Col>

            <Col md={6}>
                <Card className="shadow-sm">
                    <Card.Body className="row">
                        <div className="col col-4">
                            <h6>Administradores</h6>
                            <h3>{users.filter(item => item.type == 1).length}</h3>
                        </div>
                        <div className="col col-4">
                            <h6>Corporativos</h6>
                            <h3>{users.filter(item => item.type == 2).length}</h3>
                        </div>
                        <div className="col col-4">
                            <h6>Individuais</h6>
                            <h3>{users.filter(item => item.type == 3).length}</h3>
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        </Row>

    )

}